import _classCallCheck from "/bitnami/jenkins/home/workspace/Production/Frontend/member_app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/bitnami/jenkins/home/workspace/Production/Frontend/member_app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Store = /*#__PURE__*/function () {
  function Store(t) {
    _classCallCheck(this, Store);

    var n = this;
    n.actions = {}, n.mutations = {}, n.state = {}, n.status = "resting", n.callbacks = [], t.hasOwnProperty("actions") && (n.actions = t.actions), t.hasOwnProperty("mutations") && (n.mutations = t.mutations), n.state = new Proxy(t.initialState || {}, {
      set: function set(t, o, s) {
        return t[o] = s, n.processCallbacks(n.state), n.status = "resting", !0;
      }
    });
  }

  _createClass(Store, [{
    key: "dispatch",
    value: function dispatch(t, n) {
      var o = this;
      return "function" != typeof o.actions[t] ? (console.error("Action \"".concat(t, "\" doesn't exist.")), !1) : (o.status = "action", o.actions[t](o, n));
    }
  }, {
    key: "commit",
    value: function commit(t, n) {
      var o = this;
      if ("function" != typeof o.mutations[t]) return console.error("Mutation \"".concat(t, "\" doesn't exist")), !1;
      o.status = "mutation";
      var s = o.mutations[t](o.state, n);
      return o.state = s, !0;
    }
  }, {
    key: "processCallbacks",
    value: function processCallbacks(t) {
      var n = this;
      return !!n.callbacks.length && (n.callbacks.forEach(function (n) {
        return n(t);
      }), !0);
    }
  }, {
    key: "subscribe",
    value: function subscribe(t) {
      var n = this;
      return "function" != typeof t ? (console.error("You can only subscribe to Store changes with a valid function"), !1) : (n.callbacks.push(t), !0);
    }
  }]);

  return Store;
}();

export default Store;